import React, { useState, useEffect } from 'react';
import { useTranslation } from '../../Translation';
import useAuthenticated from '../Dashboard/useAuthenticated';
import { useAPI } from '../../API';
import { useAppDispatch, useAppState } from '../../Store';
import { useParams } from 'react-router-dom';
import SidebarNav from '../../Components/SidebarNav/SidebarNav';
import LoadingCircleTransparent from '../../Components/LoadingIndicators/LoadingCircleTransparent';
import { ReportChart } from './Report';
import { PencilIcon } from '@heroicons/react/24/solid';
import { ReportModal } from './Reports';
import { useRefresh } from '../../Hooks/useRefresh';
import Modal from '../../Components/Modal';

export default function Board() {

    const { translate, language, setLanguage } = useTranslation();

    const { isAuthenticated, pathAfterLogin } = useAuthenticated();

    const api = useAPI();

    const appState = useAppState();
    const dispatch = useAppDispatch();
    const { sidebarSearch } = appState;
    const [loading, setLoading] = useState(true);
    const boardId = useParams().boardId;
    const [board, setBoard] = useState(null);
    const [boards, setBoards] = useState([]);
    const [open, setOpen] = useState(false);
    const { refreshId, refresh } = useRefresh();
    const [selectedReport, setSelectedReport] = useState(null);

    useEffect(() => {
        setLoading(true);
        api.getBoard(boardId).then((response) => {
            setBoard(response.data.board);
            setLoading(false);
        });

        api.getBoards().then((response) => {
            setBoards(response.data.boards);
        });
    }, [boardId, refreshId]);

    const getReportColSpan = (report) => {
        if (report.number_of_blocks_in_board === 1) {
            return 'col-span-1';
        }
        if (report.number_of_blocks_in_board === 2) {
            return 'col-span-2';
        }
        if (report.number_of_blocks_in_board === 3) {
            return 'col-span-3';
        }
        if (report.number_of_blocks_in_board === 4) {
            return 'col-span-4';
        }

        return 'col-span-2';
     }

    const updateReport = (report) => {
        setSelectedReport(report);
        setOpen(true);
    }
    
    return (
        <>
        <Modal open={open} onClose={() => setOpen(false)} title={translate('reports.edit')} children={<ReportModal boards={boards} refresh={refresh} setOpen={setOpen} report={selectedReport} setSelectedReport={setSelectedReport} open={open} />} />
        
        <div className="flex min-h-full w-full">
            <SidebarNav contentPadding={false} currentPage="reports">
                {loading ? <div className="flex justify-center items-center h-full w-12 m-8">
                    <LoadingCircleTransparent />
                </div> : (
                    <div className="p-8 grid grid-cols-4 gap-4">
                        <h1 className="text-2xl font-bold col-span-4 mb-8">{board.name}</h1>
                        {board.reports.map((report) => (
                            <div className={`${getReportColSpan(report.report)} border border-gray-200 rounded-md pb-12 px-4 pt-4 h-72`} key={report.id}>
                                <div className="flex flex-row items-center justify-between border-b border-gray-200 pb-4">
                                    <h2 className="text-lg font-bold">{report.report.name}</h2>
                                    <PencilIcon onClick={() => updateReport(report.report)} className="w-4 h-4 text-gray-400 cursor-pointer" />
                                </div>
                                
                                <ReportChart report={report.report} results={report.results} isMonthly={false} />
                            </div>
                        ))}
                    </div>
                )}
            </SidebarNav>
        </div>
        </>
    );
}